module.exports = __webpack_public_path__ + "static/media/undraw_ethereum_fb7n.0effc44e.svg";